<template>
  <div class="container-resultado">
    <i class="fas fa-times-circle" id="reprovado" v-if="!aprovado"></i>
    <i class="fas fa-medal" id="aprovado" v-if="aprovado"></i>

    <Panel
      :lineColor="aprovado ? 'var(--primary-color)' : 'rgba(255, 0, 0, 0.6)'"
      style="margin-bottom: 20px;"
    >
      <div class="resultado">
        <h2>
          Resultado: <span>{{ aprovadoTxt }}</span>
        </h2>

        <div v-if="aprovado" class="mensagem-resultado">
          Agora você pode usar a parte correspondente do portal. <br />
          Recomendamos que você faça todos os cursos disponíveis.
        </div>

        <div v-else>
          <div class="mensagem-resultado">
            Você não acertou o mínimo de <strong>75%</strong> das questões da
            avaliação.<br />
            Você pode rever os videos ou tentar fazer a avaliação novamente
          </div>

          <div v-if="history" class="history-result">
            <h2>Pontuação</h2>

            <div class="pontuacao">
              <div class="corretas" v-if="history.resultado_avaliacao">
                <strong>{{
                  history.resultado_avaliacao.resultTotal.right
                }}</strong>
                corretas
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="erradas" v-if="history.resultado_avaliacao">
                <strong>{{
                  history.resultado_avaliacao.resultTotal.wrong
                }}</strong>
                erradas
                <i class="fas fa-times-circle"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Panel>

    <FormButtonGroup align="space-around" spaced>
      <FormButton
        text="Voltar à avaliação"
        type="submissao"
        :rounded="false"
        @click="acaoBotao('voltar')"
      />
      <FormButton
        text="Rever os vídeos"
        type="primario"
        :rounded="false"
        @click="acaoBotao('rever')"
      />
    </FormButtonGroup>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import FormButton from "@/components/form/FormButton";
import { mapGetters } from "vuex";

export default {
  props: {
    history: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  components: {
    Panel,
    FormButtonGroup,
    FormButton
  },
  computed: {
    ...mapGetters(["getVideosAcademy"]),
    aprovado() {
      if (this.history && this.history.secao_concluida) {
        return true;
      }
      return false;
    },
    aprovadoTxt() {
      if (this.aprovado) {
        return "Parabéns! Você concluiu essa seção do curso. ";
      } else {
        return "Você ainda não concluiu a avaliação do curso. ";
      }
    },
    sections() {
      return this.getVideosAcademy || [];
    },
    sectionAtual() {
      const { sectionid } = this.$route.params;
      const sectionAtual =
        this.sections.find(section => section.idSection === sectionid) || {};
      return sectionAtual;
    }
  },
  methods: {
    acaoBotao(acao) {
      const { sectionid } = this.$route.params;
      const lessonId = this.sectionAtual?.lessons[0].id;

      switch (acao) {
        case "voltar":
          this.$emit("resetarProva");
          break;

        case "rever":
          this.$router.push(`/ead/section/${sectionid}/lesson/${lessonId}`);
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
i {
  font-size: 200px;
  margin-bottom: 40px;
}

#aprovado {
  color: var(--primary-color);
}

#reprovado {
  color: rgba(255, 0, 0, 0.6);
}

.container-resultado {
  margin-top: 100px;
}

.resultado {
  color: #6a6c6f;
}

.resultado h2 span {
  font-weight: 500;
  font-size: 20px;
}

.mensagem-resultado {
  text-align: start;
  margin-top: 10px;
  margin-bottom: 10px;
}

.pontuacao {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
  margin-bottom: 20px;
}

.pontuacao i {
  font-size: 20px;
  margin: 0;
  padding-left: 5px;
}

.pontuacao .corretas {
  background: #50b748;
  padding: 10px;
  border-radius: 5px;
  color: white;
  border: 2px solid #469f3f;
}

.pontuacao .erradas {
  background: rgba(255, 0, 0, 0.6);
  padding: 10px;
  border-radius: 5px;
  color: white;
  border: 2px solid rgba(234, 3, 3, 0.6);
}
</style>

<style lang="scss">
.v-application.theme--dark .container-resultado {
  .resultado,
  .mensagem-resultado,
  .history-result h2 {
    color: rgba(255, 255, 255, 0.87);
  }

  .resultado h2 span {
    color: rgba(255, 255, 255, 0.95);
  }
}
</style>
